import { call, put } from 'redux-saga/effects'
import I18n from '../i18n/i18n'
import AdminActions from '../Redux/AdminRedux'
import { AlertService } from '../Services/Alert'

export function * updateStripeSecretKey (api, action) {
  const { secretKey } = action
  const response = yield call(api.updateStripeSecretKey, secretKey)
  const { ok, data } = response
  if (ok) {
    yield put(AdminActions.updateStripeKeySuccess())
    AlertService.success(I18n.t('snacks.success.updateStripeKey'))
  } else {
    const errorMessage = data?.error || I18n.t('snacks.errors.updateStripeKey')
    yield put(AdminActions.updateStripeKeyFailure(errorMessage))
    AlertService.error(errorMessage)
  }
}
